import React from 'react';
import styled from 'styled-components';
import { TFunction } from 'i18next';
import { withTranslation } from 'react-i18next';

type EtaProps = {
    className?: string;
    eta?: string;
    t: TFunction;
};

const EtaContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Graphik LCG', sans-serif;
    padding: 26px 0 0 0;
`;

const TimeContainer = styled.div`
    font-size: 30px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #263238;
`;

const TextContainer = styled.div`
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #647882;
`;

const EtaComp = (etaProps: EtaProps) => {
    if (!etaProps?.eta) return null;

    const { t, eta, className } = etaProps;
    return (
        <EtaContainer className={className}>
            <TimeContainer>{eta}</TimeContainer>
            <TextContainer>{t('Estimated')}</TextContainer>
        </EtaContainer>
    );
};

export const Eta = withTranslation(['eta'])(EtaComp);
